import React from 'react';
import classNames from 'classnames';

const DropdownItem = ({ item, index }) => (
  <div
    className={classNames('px-2 py-4 text-xs', {
      'border-t border-gray-light6': index !== 0,
    })}
  >
    {item?.text}
    {item?.subtext && (
      <div className="text-[10px]">
        {item?.subtext?.length > 22
          ? `${item?.subtext?.substr(0, 22)}...`
          : item?.subtext}
      </div>
    )}
  </div>
);

export default DropdownItem;
